import { render } from "./SlipCard.vue?vue&type=template&id=6c4d0c46&scoped=true"
import script from "./SlipCard.vue?vue&type=script&lang=js"
export * from "./SlipCard.vue?vue&type=script&lang=js"

import "./SlipCard.vue?vue&type=style&index=0&id=6c4d0c46&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4d0c46"]])

export default __exports__